import React from 'react';
import OrderDirectionsEnum from '../../../../Enums/OrderDirectionsEnum';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import TpCreditMemoLineSearchParams from './TpCreditMemoLineSearchParams';
import TpCreditMemoLineItem from '../../../../Domain/CreditMemo/TpCreditMemoLineItem';
import TpCreditMemoLineService from '../../../../Services/CreditMemo/TpCreditMemoLineService';
import TpCreditMemoService from '../../../../Services/CreditMemo/TpCreditMemoService';
import TpClientInvoiceService from '../../../../Services/TpClientInvoiceService';
import FigmaButtonRow from '../../../../Elements/FigmaButtonRow';
import ButtonTypeEnum from '../../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../../Enums/IconPositionEnum';
import ShownPanelsEnum from '../../../../Enums/ShownPanelsEnum';
import GeneralEditWizzardBase from '../../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import ErrorMessage from '../../../../Elements/ErrorMessage';
import TpCreditMemoStatusEnum from '../../../../Enums/CreditMemoStatusEnum';
import TpCreditMemoReasonEnum from '../../../../Enums/CreditMemoReasonEnum';
import TpCreditMemoApplyItem from '../../../../Domain/CreditMemo/TpCreditMemoApplyItem';
import ApplyCreditWindowDescription from './ApplyCreditWindowDescription';
import LoadingFullScreen from '../../../../Elements/LoadingFullScreen';

export default class TpCreditMemoDetailLineTab extends React.Component {
  static defaultProps = {
    tpCreditMemoId: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      searchItem: new TpCreditMemoLineSearchParams(),
      itemList: [],
      allItemsInTheSearchSetAreSelected: false,
      shownPanel: ShownPanelsEnum.None,
      creditMemo: null,
      selectedItem: null,
      loading: false,
    };

    this.state.searchItem.TpCreditMemoId = this.props.tpCreditMemoId;

    ApplyCreditWindowDescription.getSearchParameters = this.getSearchParameters.bind(this);
    ApplyCreditWindowDescription.getSelected = this.getSelected.bind(this);
    ApplyCreditWindowDescription.getAllItemsInTheSearchSetAreSelected =
      this.getAllItemsInTheSearchSetAreSelected.bind(this);

    this.startSearch = this.startSearch.bind(this);
  }

  componentDidMount() {
    this.getCreditMemoRequestData();
  }

  getAllItemsInTheSearchSetAreSelected() {
    return this.state.allItemsInTheSearchSetAreSelected;
  }

  getSearchParameters() {
    return this.state.searchItem;
  }

  getSelected() {
    return this.state.itemList.filter((u) => u.Selected === true);
  }

  refresh(refresh) {
    if (refresh) {
      this.setState({ shownPanel: ShownPanelsEnum.None, searchItem: { ...this.state.searchItem }, loading: false });
      this.getCreditMemoRequestData();
      return;
    }
    this.setState({ shownPanel: ShownPanelsEnum.None, loading: false });
  }

  getCreditMemoRequestData() {
    TpCreditMemoService.GetById(this.props.tpCreditMemoId)
      .then((result) => {
        TpClientInvoiceService.GetById(result.tpClientInvoiceId).then((inv) =>
          this.setState({ creditMemo: { ...result }, invoiceMaxTotal: inv.total })
        );
      })
      .catch((error) => ErrorMessage.SetErrorMessage('TPCMDLT79', error));
  }

  applyCreditButtonClicked(ActionText, isApply, isLateFeeReimbursement = false) {
    if (this.getSelected().length > 100) {
      ErrorMessage.SetErrorMessage(
        'You cannot have more than 100 items selected on the same page. Use the "select all line items" button with narrowed down search parameters.'
      );
      return;
    }

    TpCreditMemoLineService.GetDataForCreditApply(
      this.getSearchParameters(),
      this.getAllItemsInTheSearchSetAreSelected(),
      this.getSelected()
    )
      .then((result) => {
        if (result.error) {
          ErrorMessage.SetErrorMessage(result.error);
          this.setState({ loading: false });
          return;
        }

        const selectedItem = new TpCreditMemoApplyItem(
          isApply,
          isLateFeeReimbursement,
          result,
          this.state.creditMemo,
          this.state.invoiceMaxTotal
        );

        if (
          this.state.creditMemo.reason !== TpCreditMemoReasonEnum.TaxCredit &&
          this.state.creditMemo.reason !== TpCreditMemoReasonEnum.LateFeeCredit
        ) {
          this.setState({ shownPanel: ShownPanelsEnum.ApplyCredit, selectedItem: selectedItem, loading: false });
          return;
        }

        this.setState({ loading: false });
        ErrorMessage.SetApprove(`${ActionText} for selected line items. Are you sure?`, () =>
          this.handleCreditApplyApprove(selectedItem)
        );
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('TPCMDLT121', error);
        this.setState({ loading: false });
      });
    this.setState({ loading: true });
  }

  handleCreditApplyApprove(editItem) {
    TpCreditMemoLineService.ApplyCredit(
      editItem,
      this.getSelected(),
      this.getSearchParameters(),
      this.getAllItemsInTheSearchSetAreSelected()
    )
      .then((result) => {
        if (result.success && result.success.length > 0) {
          const successMessage = this.getResultMessageFromArray(result.success);
          ErrorMessage.SetNotification(successMessage);
        }
        if (result.failure && result.failure.length > 0) {
          const failureMessage = this.getResultMessageFromArray(result.failure);
          ErrorMessage.SetErrorMessage(failureMessage);
        }

        this.refresh(true);
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('TPCMDLT143', error);
        this.setState({ loading: false });
      });
  }

  getResultMessageFromArray(result) {
    return (
      <div>
        {result.map((s) => (
          <div>{s}</div>
        ))}
      </div>
    );
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.ApplyCredit,
          <GeneralEditWizzardBase
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.refresh(false)}
            clickOnSave={() => this.refresh(true)}
            windowDescription={ApplyCreditWindowDescription}
            errorCode={'TPCMDLT170'}
          />
        )}
      </div>
    );
  }

  renderButtonsAndPanels() {
    if (!this.state.creditMemo) return null;

    if (this.state.loading) {
      return <LoadingFullScreen />;
    }

    const isButtonDisabled =
      this.getSelected().length === 0 || this.state.creditMemo.status !== TpCreditMemoStatusEnum.Created;
    const labelText =
      this.state.creditMemo.reason === TpCreditMemoReasonEnum.TaxCredit ||
      this.state.creditMemo.reason === TpCreditMemoReasonEnum.LateFeeCredit
        ? this.state.creditMemo.reason
        : 'Credit';
    return (
      <>
        <FigmaButtonRow
          buttons={[
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Primary,
              iconPosition: IconPositionEnum.None,
              onClick: () => this.applyCreditButtonClicked(`Apply ${labelText}`, true),
              label: `Apply ${labelText}`,
              tooltip: `Apply ${labelText}`,
              roleKey: 'tpcreditmemo_createandmodifycredit',
              disabled: isButtonDisabled,
            },
            {
              type: ButtonTypeEnum.ExtraLargeNormal,
              color: ButtonColorsEnum.Primary,
              iconPosition: IconPositionEnum.None,
              onClick: () => this.applyCreditButtonClicked(`Apply Reimbursement ${labelText}`, true, true),
              label: `Apply Reimb. ${labelText}`,
              tooltip: `Apply Reimbursement ${labelText}`,
              roleKey: 'tpcreditmemo_createandmodifycredit',
              hidden: this.state.creditMemo.reason !== TpCreditMemoReasonEnum.TaxCredit,
              disabled: isButtonDisabled,
            },
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Destruct,
              iconPosition: IconPositionEnum.None,
              onClick: () => this.applyCreditButtonClicked(`Unapply ${labelText}`, false),
              label: `Unapply ${labelText}`,
              tooltip: `Unapply ${labelText}`,
              roleKey: 'tpcreditmemo_createandmodifycredit',
              hidden:
                this.state.creditMemo.reason !== TpCreditMemoReasonEnum.TaxCredit &&
                this.state.creditMemo.reason !== TpCreditMemoReasonEnum.LateFeeCredit,
              disabled: isButtonDisabled,
            },
          ]}
        />
        {this.renderPanels()}
      </>
    );
  }

  startSearch(searchItem) {
    this.setState({ searchItem: { ...searchItem, TpCreditMemoId: this.props.tpCreditMemoId } });
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={TpCreditMemoLineItem}
          serviceFunction={TpCreditMemoLineService.GetListBySearching}
          convertDBItemsFunction={TpCreditMemoLineService.ConvertDBItems}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Desc}
          orderBy={'ThirdPartyLineId'}
          showSearchStrip={true}
          searchParamsType={TpCreditMemoLineSearchParams}
          clickOnStartSearch={this.startSearch}
          singleSearchLine={false}
          changeOfItemListFunction={(itemList) => {
            this.setState({
              itemList,
              allItemsInTheSearchSetAreSelected: false,
            });
          }}
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) =>
            this.setState({ allItemsInTheSearchSetAreSelected })
          }
          errorCode='TPCMDLT253'
        />
      </div>
    );
  }
}
